import { storeActiveAccount } from '../redux/reducers/accountSlice';
import { storeAccountAuth } from '../redux/reducers/authSlice';
import { store } from '../redux/store';
import { AccountRoles } from '../types/enums';
import { AuthResponse } from '../types/interfaces/auth.interfaces';
import {
  getLocalActiveAccountId,
  getLocalRefreshToken,
  setLocalActiveAccountId,
  setLocalRefreshToken,
} from '../utils/localStorageHandler';
import { getAccountById } from '../api/accountApi';
import { getAccountContextById } from './auth.service';
import { showToast } from './toast.service';
import { toastMessages } from '../constants/errorMessages';

export const setActiveAccount = async (accountId: number) => {
  try {
    const { data: account } = await getAccountById(accountId, { include: 'Users.Roles,Addresses' });
    const { data: accountContextAuth } = await getAccountContextById({ accountId: accountId });
    const { refreshToken, refreshTokenExpiry } = accountContextAuth as AuthResponse;

    store.dispatch(storeActiveAccount(account));
    setLocalActiveAccountId(accountId);
    store.dispatch(storeAccountAuth(accountContextAuth));

    const staySignedIn = getLocalRefreshToken() ? true : false;
    if (refreshToken && refreshTokenExpiry) {
      setLocalRefreshToken(refreshToken, staySignedIn);
    }
  } catch (err: any) {
    showToast.error(toastMessages.SOMETHING_WENT_WRONG);
  }
};

export const requestActiveAccount = async () => {
  try {
    let activeAccountId = getLocalActiveAccountId();

    if (!activeAccountId) {
      const accounts = store.getState().user.accounts;

      const ownedAccounts = accounts.filter(account => account.roles.some(role => role.name.includes(AccountRoles.AccountOwner)));

      if (ownedAccounts.length > 0) {
        activeAccountId = ownedAccounts[0].accountId;
      } else if (accounts.length > 0) {
        activeAccountId = accounts[0].accountId;
      }
    }
    if (activeAccountId) {
      setActiveAccount(activeAccountId);
    } else {
      throw new Error('No active account found');
    }
  } catch (err: any) {
    throw err;
  }
};

export const centsToDollars = (cents?: number) => {
  if (cents) {
    const dollars = cents / 100;
    return cents % 100 === 0 ? dollars : dollars.toFixed(2);
  }
  return 0;
};

export const dollarsToCents = (dollars: number) => {
  if (dollars === undefined || dollars === null) {
    return 0;
  }
  return Math.round(dollars * 100);
};
